module.exports = __webpack_public_path__ + "static/media/Universal.e6ff818e.png";